import React from "react";

export default function StripeDisplayError({ error }) {
  if (!error) return null;

  return (
    <div className="p-sm-t p-sm-l">
      <span className="text-danger">{error}</span>
    </div>
  );
}
